export function resolveClaudeConversationPolicyOptions(conversationPolicy) {
    const model = normalizeOptionalText(conversationPolicy?.model);
    const fallbackModel = normalizeOptionalText(conversationPolicy?.fallbackModel);
    const reasoningLevel = normalizeOptionalText(conversationPolicy?.reasoningLevel);
    return {
        ...(model ? { model } : {}),
        ...(fallbackModel && fallbackModel !== model ? { fallbackModel } : {}),
        ...(reasoningLevel ? { reasoningLevel } : {}),
    };
}
function normalizeOptionalText(value) {
    const normalized = String(value ?? "").trim();
    return normalized.length > 0 ? normalized : null;
}
